import { get, post, put, postForm } from '../Services/http';
import { catchError } from './Error.action';
import { CART_LOAD_ERROR, CART_RECEIVE, CART_SHOW_INFO,UPDATE_DATA } from '../constants';

export const load = () => (dispatch, getState) => {
    return get('/api/cart')
        .then((response) => response.json())
        .then((cart) => dispatch(receive(cart)))
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const loadError = (error) => ({
    type: CART_LOAD_ERROR,
    payload: {
        error,
    },
});

export const receive = (cart) => ({
    type: CART_RECEIVE,
    payload: cart,
});

export const uploadArticleData = (data) => ({
    type: UPDATE_DATA,
    payload: {
        items: data
    },
});

export const toggle = () => (dispatch, getState) => {
    dispatch(show(!getState().cart.showInfo));
};

const show = (visible) => ({
    type: CART_SHOW_INFO,
    payload: {
        showInfo: visible,
    },
});

export const updateCartFromPopup = (articleValues, selectedFile, abortController = null) => (
    dispatch
) => {
    const formData = new FormData();
    formData.append("selectedFile", selectedFile);
    formData.append("articleValues", articleValues)


    //return this.http.post(this.baseApiUrl, formData)
    return postForm(`/api/cart/updatecartfrompopup`, formData, abortController)
        .then((response) => response.json()).then((listitems) => { dispatch(uploadArticleData(listitems)); return listitems });
    //.then((response) => response.json())
    //.then((cart) => dispatch(receive(cart)))
    //.catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const RemoveListItem = (index, items) => (dispatch) => {
    items.splice(index, 1);
    dispatch(uploadArticleData(items));
}
export const AddListItems = (items) => (dispatch) => {
    items.push({ articleNumber: '', amount: 1, comment: '', validationMessage: 'validation.tobevalidated' });
    dispatch(uploadArticleData(items));

}
export const updateListItems = (items) => (dispatch) => {
    dispatch(uploadArticleData(items));

}
export const update = (articleNumber, quantity, abortController = null) => (
    dispatch
) => {
    return put(`/api/cart/update`, { articleNumber, quantity }, abortController)
        .then((response) => response.json())
        .then((cart) => dispatch(receive(cart)))
        .catch((ex) => {
            dispatch(catchError(ex, (error) => loadError(error)));
            throw ex;
        });
};

export const validateUploaded = (items, abortController = null) => (
    dispatch
) => {
    return put(`/api/cart/validateUploadedList`, { items })
        .then((response) => response.json())
        .then((listitems) => dispatch(uploadArticleData(listitems)));
};

export const updateCartList = (items, abortController = null) => (
    dispatch
) => {
    return put(`/api/cart/cartupdatefromlist`, { items })
        .then((response) => response.json())
        .then((cart) => dispatch(receive(cart)))
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
       
};

export const updateRowComment = (articleNumber, comment, abortController = null) => (
    dispatch
) => {
    return put(`/api/cart/updateRowComment`, { articleNumber, comment }, abortController)
        .then((response) => response.json())
        .then((cart) => dispatch(receive(cart)))
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};
